import http from '@/services/http';

const thermostats = {
  index(tableFilters) {
    return http.request({
      method: 'get',
      url: '/thermostats',
      params: {
        filter: {
          ...tableFilters,
        },
      },
    });
  },
  count() {
    return http.request({
      method: 'get',
      url: '/thermostats/count',
    });
  },
  show(id) {
    return http.request({
      method: 'get',
      url: `/thermostats/${id}`,
    });
  },
  getByName(name) {
    const filter = {
      where: {
        name,
      },
    };
    return http.request({
      method: 'get',
      url: '/thermostats',
      params: {
        filter,
      },
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/thermostats',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/thermostats/${id}`,
      data,
    });
  },
  getTemperatures(thermostatId) {
    return http.request({
      method: 'get',
      url: `/thermostats/${thermostatId}/temperatures`,
    });
  },
  createTemperature(thermostatId, data) {
    return http.request({
      method: 'post',
      url: `/thermostats/${thermostatId}/temperature`,
      data,
    });
  },
  autocompleteFetch(name) {
    const filter = {
      where: {
        name: {
          regexp: `/${name || ''}/i`,
        },
      },
    };
    return http.request({
      method: 'get',
      url: '/thermostats',
      params: {
        filter,
      },
    });
  },
  getTemperatureTrail(filter) {
    return http.request({
      method: 'get',
      url: '/temperature-trails',
      params: {
        filter,
      },
    });
  },
  createTemperatureTrail(data) {
    return http.request({
      method: 'post',
      url: '/temperature-trails',
      data,
    });
  },
  deleteTemperatureTrail(id) {
    return http.request({
      method: 'delete',
      url: `/temperature-trails/${id}`,
    });
  },
  closeTemperatureTrail(labSampleAnalysisId, data) {
    return http.request({
      method: 'post',
      url: `/temperature-trails/active/${labSampleAnalysisId}/end`,
      data,
    });
  },
  getTemperatureTrailByLabSample(params) {
    return http.request({
      method: 'get',
      url: '/temperature-trails/by-lab-sample',
      params,
    });
  },
  getTemperatureTrailSearch(tableFilters, where, config = {}) {
    return http.request({
      method: 'get',
      url: '/temperature-trail-list/search',
      params: {
        filter: {
          ...tableFilters,
          where,
        },
      },
      ...config,
    });
  },
  getTemperatureTrailSearchCount(where, config = {}) {
    return http.request({
      method: 'get',
      url: '/temperature-trail-list/search/count',
      params: {
        where,
      },
      ...config,
    });
  },
};

export default thermostats;
